export default __webpack_public_path__ + "static/media/portfolio-pic.1e91fc83.jpg";